//import {test_function} from "./../functions/test_function.js";



import { getId } from "../../universal_methods/getId.js";
import { setId } from "../../universal_methods/setId.js";
import { generateId } from "../../universal_methods/generateId.js";
import { isEmpty } from "../../universal_methods/isEmpty.js";
import { getAttributes } from "../../universal_methods/getAttributes.js";
import { toggleDisplay } from "../../universal_methods/toggleDisplay.js";

import { setTxt } from "../../universal_methods/setTxt.js";



// //import "./styles/_main.scss";
import { debounce } from "throttle-debounce";

// import { isValidHexColor } from "@schaniag/private";
// import { copyToClipboard } from "../../../functions/copyAndPaste/copyToClipboard.js";
// import { SmetioCustomCheckbox } from "../../smetioOnOffSwitch/SmetioCustomCheckbox.js";


export class SmetioColorInput {

  constructor(data = {
    colorName: "accentColor", // SEE SmetioColorSchemeMaker FOR ALL THE DIFFERENT COLOR NAME
    tintGap: 10,
    shadeGap: 10,
    matchBrand: false,
  }) {


    this.getId = getId;
    this.setId = setId;
    this.generateId = generateId;
    this.isEmpty = isEmpty;
    this.getAttributes = getAttributes;
    this.toggleDisplay = toggleDisplay;
    this.setTxt = setTxt;

    this.mainObj = data || {};
    this.isReadonly = this.mainObj.isReadonly || false;

    this.value = data.attributes.value || {};
    this.colorName = data.colorName || "accentColor";
    this.onChange = data.events.onChange;
    this.colorCode = this.value.code || "";
    this.color = this.colorCode;
    this.tintGap = this.value.tintGap || 10;
    this.shadeGap = this.value.shadeGap || 10;
    this.matchBrand = this.value.matchBrand || false;

    this.setId();

    if (!window.smetioColorScheme) window.smetioColorScheme = {
      prefix: "",
      gapBetweenShadesAndTints: "",
      adjustContrast: ""
    };

    window.smetioColorScheme[this.colorName] = {
      code: this.colorCode,
      tintGape: this.tintGap,
      shadeGap: this.shadeGap,
      matchBrand: this.matchBrand,
    };


    this.mainClass = "smetio-color-input-" + this.id;
    this.mainAttributes = {
      class: ["smetio-color-input", this.mainClass],
    };

    this.colorPickerInputClass = "smetio-color-input-color-picker-input-" + this.id;
    this.colorPickerInputAttributes = {
      value: this.colorCode,
      type: "color",
      class: ["smetio-color-input-color-picker-input", `smetio-color-input-color-picker-input-${this.colorName}`, this.colorPickerInputClass],
    };

    this.colorCodeInputClass = "smetio-color-input-color-code-input-" + this.id;
    this.colorCodeInputAttributes = {
      placeholder: "txt470",
      value: this.colorCode,
      type: "text",
      class: ["smetio-color-input-color-code-input", `smetio-color-input-color-code-input-${this.colorName}`, this.colorCodeInputClass],
    };

    this.tintGapClass = "smetio-color-input-tint-gap-input-" + this.id;
    this.tintGapAttributes = {
      type: "number",
      min: 1,
      max: 100,
      step: 1,
      value: this.tintGap,
      class: ["smetio-color-input-tint-gap-input", `smetio-color-input-tint-gap-input-${this.colorName}`, this.tintGapClass],
    };

    this.shadeGapClass = "smetio-color-input-shade-gap-input-" + this.id;
    this.shadeGapAttributes = {
      type: "number",
      min: 1,
      max: 100,
      step: 1,
      value: this.shadeGap,
      class: ["smetio-color-input-shade-gap-input", `smetio-color-input-shade-gap-input-${this.colorName}`, this.shadeGapClass],
    };

    // this.matchBrandClass = "smetio-color-input-match-brand-input-" + this.id;
    // this.matchBrandAttributes = {
    //   class: ["smetio-color-input-match-brand-input", `smetio-color-input-match-brand-input-${this.colorName}`, this.matchBrandClass],
    // };

    this.previewBtnClass = "smetio-color-input-advanced-settings-preview-btn-" + this.id;
    this.previewBtnAttributes = {
      class: ["smetio-color-input-advanced-settings-preview-btn", this.previewBtnClass],
    };

    this.advancedSettingsBtnClass = "smetio-color-input-advanced-settings-btn-" + this.id;
    this.advancedSettingsBtnAttributes = {
      "data-smetio-read-only": this.isReadonly,
      class: ["smetio-color-input-advanced-settings-btn", this.advancedSettingsBtnClass],
    };

    this.advancedSettingsDivClass = "smetio-color-input-advanced-settings-div-" + this.id;
    this.advancedSettingsDivAttributes = {

      "data-smetio-is-visible": false,
      "data-smetio-read-only": this.isReadonly,

      class: ["smetio-color-input-advanced-settings-div", this.advancedSettingsDivClass],
    };

  };

  getValue() {

    this.colorHasChanged("getValue");

    return this.value;
  };

  changeReadonlyStatus({ newStatus }) {
    $(`.${this.mainClass}`).attr("data-smetio-read-only", newStatus);
    $(`.${this.mainClass} *`).attr("data-smetio-read-only", newStatus);
  };

  async codeIsValidHexColor() {

    const isValidSmetioColorInput = (await import(/* webpackPrefetch: true */ `@schaniag/private`)).isValidSmetioColorInput;

    if (this.isEmpty(this.value.code) && this.mainObj.validation.required == true) return "txt56";

    return isValidSmetioColorInput(this.value);

  };

  colorHasChanged(from) {

    // if (this.isEmpty(this.color)) this.color = this.colorCode;

    if (from == "colorCodeInput") $(`.${this.colorPickerInputClass}`).val(this.color);
    if (from == "colorPickerInput") $(`.${this.colorCodeInputClass}`).val(this.color);

    window.smetioColorScheme[this.colorName] = {
      code: this.color,
      tintGap: this.tintGap,
      shadeGap: this.shadeGap,
      matchBrand: this.matchBrand,
    };
    this.value = window.smetioColorScheme[this.colorName];

    if (this.onChange && from !== "getValue") this.onChange(this.value);

    this.getSmetioColorSchemeMaker();
  };

  async copyCssCode() {

    const copyToClipboard = (await import(/* webpackPrefetch: true */ `../../../functions/copyAndPaste/copyToClipboard.js`)).copyToClipboard;

    copyToClipboard({
      theDataToCopy: window.smetioColorSchemeMaker.getCssCodeForStyleFile(),
      onSuccessFunc: () => {
        alert("Copied to clipboard");
      },
      onFailedFunc: () => {
        alert("Failed to copy to clipboard");
      },
    });

  };

  getPreDefinedPallettes() {

    if (window.predefinedPalette) return window.predefinedPalette;

    const preDefinedPalettes = {
      uniqueName1: {
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName1.jpeg`,
        accentColor: {
          code: "#F2E0C9",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#732F6E",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#ffffff",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#BFA995",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        successColor: {
          code: "#B1F2E6",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#C9E4F2",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#BF3939",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },


      },
      uniqueName2: {
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName2.jpeg`,
        accentColor: {
          code: "#D9C9BA",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#172621",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#ffffff",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#A6907C",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        successColor: {
          code: "#A5D9C7",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#273F59",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#D95E32",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },

      },
      uniqueName3: {
        // coverPicture: "img/appImages/colorPaletteImage/uniqueName3.jpeg",
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName3.jpeg`,
        accentColor: {
          code: "#A9C2D9",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#0D0D0D",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#ffffff",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#A6806A",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,

        },
        successColor: {
          code: "#B4D9A9",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#2E4559",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#BF613F",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },


      },
      uniqueName4: {
        // coverPicture: "img/appImages/colorPaletteImage/uniqueName4.jpeg",
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName4.jpeg`,
        accentColor: {
          code: "#F28F79",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#733832",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#ffffff",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#F2BE22",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,

        },
        successColor: {
          code: "#79F2C7",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#79DBF2",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#F24535",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },


      },
      uniqueName5: {
        // coverPicture: "img/appImages/colorPaletteImage/uniqueName5.jpeg",
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName5.jpeg`,
        accentColor: {
          code: "#DDCEF2",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#140961",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#ffffff",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#F59C61",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,

        },
        successColor: {
          code: "#CEF2E2",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#230BBF",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#F26161",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },


      },
      uniqueName6: {
        // coverPicture: "img/appImages/colorPaletteImage/uniqueName6.jpeg",
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName6.jpeg`,
        accentColor: {
          code: "#F9F6EB",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#4A2D1C",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#FFFFFF",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#B4803C",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        successColor: {
          code: "#39AC6B",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#3B8BAB",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#AB3B46",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
      },
      uniqueName7: {
        // coverPicture: "img/appImages/colorPaletteImage/uniqueName7.jpg",
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName7.jpeg`,
        accentColor: {
          code: "#EAEAE7",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#262624",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#FFFFFF",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#808080",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#FFFFA7",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        successColor: {
          code: "#6B6B21",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#214C6B",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#6B2321",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
      },
      uniqueName8: {
        // coverPicture: "img/appImages/colorPaletteImage/uniqueName7.jpg",
        coverPicture: `${window.cdnPath}/img/appImages/colorPaletteImage/uniqueName8.jpeg`,
        accentColor: {
          code: "#f9d95a",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dominantColor: {
          code: "#000000",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        neutralColor: {
          code: "#ffffff",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        greyColor: {
          code: "#ebebeb",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        warningColor: {
          code: "#FAB15A",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        successColor: {
          code: "#49B975",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        informationColor: {
          code: "#4A7BCF",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
        dangerColor: {
          code: "#FA5D5A",
          tintGap: 10,
          shadeGap: 10,
          matchBrand: false,
        },
      }        
    };

    // const cdnPath = "http://localhost:3000/";
    let output = "";

    for (const key in preDefinedPalettes) {

      const palette = preDefinedPalettes[key];
      const presentation = `
        <div data-smetio-id="${key}" class="smetio-color-input-pre-defined-palette-div">

          <div class="smetio-color-input-pre-defined-palette-cover-picture-div">
            <img src="${palette.coverPicture}" alt="cover picture">
          </div>

          <div class="smetio-color-input-pre-defined-palette-colors-div">
            <div style="background-color:${palette.accentColor.code};"></div>
            <div style="background-color:${palette.dominantColor.code};"></div>
            <div style="background-color:${palette.neutralColor.code};"></div>
            <div style="background-color:${palette.greyColor.code};"></div>
            <div style="background-color:${palette.warningColor.code};"></div>
            <div style="background-color:${palette.successColor.code};"></div>
            <div style="background-color:${palette.informationColor.code};"></div>
            <div style="background-color:${palette.dangerColor.code};"></div>
          </div>

        </div>
      `
      output += presentation;

    };


    $("body").on("mousedown", ".smetio-color-input-pre-defined-palette-div", function () {

      const uniqueId = $(this).attr("data-smetio-id");
      const palette = preDefinedPalettes[uniqueId];

      for (const key in palette) {

        if (key === "coverPicture") continue;

        const { code, tintGap, shadeGap, matchBrand } = palette[key];
        $(`.smetio-color-input-shade-gap-input-${key}`).val(shadeGap);
        $(`.smetio-color-input-tint-gap-input-${key}`).val(tintGap);
        // $(`.smetio-color-input-match-brand-${key}`).prop("checked", matchBrand);
        $(`.smetio-color-input-color-code-input-${key}`).val(code).trigger("keyup");

        window.colorSchemePreview.close();
      };


    });

    $("body").on("mousedown", ".smetio-color-input-color-scheme-advance-preview-btn", function () {

      const isVisible = $(".smetio-advance-color-scheme").attr("data-smetio-is-visible") == "yes" ? "no" : "yes";

      $(".smetio-advance-color-scheme").slideToggle().attr("data-smetio-is-visible", isVisible);

      const arrow = isVisible == "yes" ? `<i class="smetio-icon smetio-icon-arrow-up3"></i>` : `<i class="smetio-icon smetio-icon-arrow-down3"></i>`;

      $(".smetio-color-input-color-scheme-advance-preview-btn-icon").html(arrow);

    });

    let countDown = 0;
    $("body").on("mousedown", ".smetio-color-input-color-scheme-title", () => {
      countDown = setTimeout(async () => {
        this.copyCssCode();

      }, 500);
    });

    $("body").on("mouseup", ".smetio-color-input-color-scheme-title", () => {
      clearTimeout(countDown);
    });

    window.predefinedPalette = output;

    return window.predefinedPalette;

  };

  async getSmetioColorSchemeMaker() {

    const SmetioColorSchemeMaker = (await import(/* webpackPrefetch: true */ `../../smetioColorSchemeMaker/v1.0.0/SmetioColorSchemeMaker`)).SmetioColorSchemeMaker;

    if (!window.smetioColorSchemeMaker) window.smetioColorSchemeMaker = new SmetioColorSchemeMaker(window.smetioColorScheme);

    window.smetioColorSchemeMaker.reRender(window.smetioColorScheme);

    $(".smetio-advance-color-scheme").html(window.smetioColorSchemeMaker.getColorPallete());

    localStorage.setItem("cssCodeForFile", window.smetioColorSchemeMaker.getCssCodeForStyleFile());

  };

  async getSmetioCustomCheckbox() {

    const SmetioCustomCheckbox = (await import(/* webpackPrefetch: true */ `../../smetioCustomCheckbox/v1.0.0/SmetioCustomCheckbox`)).SmetioCustomCheckbox;

    this.mainObj.attributes.checked = this.matchBrand;
    this.mainObj["changeEvents"] = {
      onChecked: () => {
        this.matchBrand = true;
        this.colorHasChanged();
      },
      onUnChecked: () => {
        this.matchBrand = false;
        this.colorHasChanged();
      },
    };

    this.smetioCustomCheckbox = new SmetioCustomCheckbox({
      attributes: {
        checked: this.matchBrand
      },
      changeEvents: {
        onChecked: () => {
          this.matchBrand = true;
          this.colorHasChanged();
        },
        onUnChecked: () => {
          this.matchBrand = false;
          this.colorHasChanged();
        },
      }
    });

    return this.smetioCustomCheckbox.render();

  };

  async render() {


    this.events();

    const matchBrandColorSwitch = await this.getSmetioCustomCheckbox();

    // setTimeout(() => {

    //   if(this.isEmpty(this.colorCode)) return false;

    //   this.color = this.colorCode;
    //   this.colorHasChanged();
    // }, 200);

    return `
        <div ${this.getAttributes(this.mainAttributes, false)} >

          <div data-smetio-read-only="${this.isReadonly}" class="smetio-color-input-color-picker-and-code-div" >

            <div class="smetio-color-input-color-picker-input-div">
              <input ${this.getAttributes(this.colorPickerInputAttributes, false)} >
            </div>

            <div class="smetio-color-input-color-code-input-div">
              <input ${this.getAttributes(this.colorCodeInputAttributes, false)} >
            </div>

            <div  data-smetio-read-only="${this.isReadonly}" class="smetio-color-input-icons-div">

              <div ${this.getAttributes(this.previewBtnAttributes, false)}>
                <i class="smetio-icon smetio-icon-eye1"></i>
              </div>

              <div ${this.getAttributes(this.advancedSettingsBtnAttributes, false)}>
                <i class="smetio-icon smetio-icon-arrow-down3"></i>
              </div>

            </div>

          </div>

          <div ${this.getAttributes(this.advancedSettingsDivAttributes, false)}>

            <div class="smetio-color-input-tint-gap-input-div">
              <i class="smetio-icon smetio-icon-brightness-contrast"></i>
              <input ${this.getAttributes(this.tintGapAttributes, false)} >
            </div>

            <div class="smetio-color-input-shade-gap-input-div">           
              <i class="smetio-icon smetio-icon-contrast1"></i>
              <input ${this.getAttributes(this.shadeGapAttributes, false)} >
            </div>

            <div class="smetio-color-input-match-brand-input-div">
              ${matchBrandColorSwitch}

            </div>
          </div>

        </div>
      `;

    /* 
                  <label>MB:</label>
            <select ${this.getAttributes(this.matchBrandAttributes, false)} >
              <option value=false>No</option>
              <option value=true>Yes</option>
            </select>
    */
  };

  showAdvancedSettings() {
    $(`.${this.advancedSettingsDivClass}`).attr("data-smetio-is-visible", true);
    $(`.${this.advancedSettingsBtnClass}`).html(`<i class="smetio-icon smetio-icon-arrow-up3"></i>`);
    this.advancedSettingsIsVisible = true;
  };

  hideAdvancedSettings() {

    $(`.${this.advancedSettingsDivClass}`).attr("data-smetio-is-visible", false);
    $(`.${this.advancedSettingsBtnClass}`).html(`<i class="smetio-icon smetio-icon-arrow-down3"></i>`);
    this.advancedSettingsIsVisible = false;

  };

  toggleAdvancedSettings() {

    if (this.advancedSettingsIsVisible) return this.hideAdvancedSettings();

    return this.showAdvancedSettings();

  };

  async previewColorScheme() {

    const SmetioSmartbox = (await import(/* webpackPrefetch: true */ `../../smetioSmartbox/v1.0.0/SmetioSmartbox`)).SmetioSmartbox;

    if (!window.colorSchemePreview) window.colorSchemePreview = new SmetioSmartbox();
    if (window.colorSchemePreview.hasBeenRendered && window.colorSchemePreview.currentState !== "close") {
      return window.colorSchemePreview.reactivate();
    };
    window.colorSchemePreview.title = "txt457";
    window.colorSchemePreview.onClose = () => {
      window.colorSchemePreview = null;
    };


    const predefinedPalette = this.getPreDefinedPallettes();

    const advancePreviewText = this.setTxt({
      attributes: {},
      txt: "txt465",
      type: "html"
    });

    const title = this.setTxt({
      attributes: {},
      txt: "txt466",
      type: "html"
    });

    const instruction = this.setTxt({
      attributes: {},
      txt: "txt467",
      type: "html"
    });

    const content = `

      <div class="smetio-color-input-pre-defined-palettes-and-color-scheme-holder">

        <h3 class="smetio-color-input-color-scheme-title">
          ${title}
        </h3>

        <p class="smetio-color-input-color-scheme-instruction">
          ${instruction}
        </p>

        <div class="smetio-color-input-pre-defined-palettes-holder">
          ${predefinedPalette}
        </div>

        <div class="smetio-color-input-color-scheme-advance-preview-btn"> 
          <div class="smetio-color-input-color-scheme-advance-preview-btn-txt">
            ${advancePreviewText}
          </div>
          <div class="smetio-color-input-color-scheme-advance-preview-btn-icon">
            <i class="smetio-icon smetio-icon-arrow-down3"></i>
          </div>
        </div>

        <div data-smetio-is-visible="no" class="smetio-advance-color-scheme">
        </div>

        <div data-smetio-is-visible="no" class="smetio-advance-color-scheme-css-code">
        </div>


      </div>

    `;

    window.colorSchemePreview.content = content;
    window.colorSchemePreview.render();

    this.getSmetioColorSchemeMaker();

  };

  events() {

    $("body").on("input propertychange change", "." + this.colorPickerInputClass, debounce(400, () => {

      this.color = $(`.${this.colorPickerInputClass}`).val();
      this.colorHasChanged("colorPickerInput");

    }));

    $("body").on("keyup", "." + this.colorCodeInputClass, debounce(400, () => {

      // console.log("You changed color code input ");

      this.color = $(`.${this.colorCodeInputClass}`).val();
      this.colorHasChanged("colorCodeInput");

    }));

    $("body").on("input propertychange change", "." + this.tintGapClass, debounce(400, () => {

      this.tintGap = $(`.${this.tintGapClass}`).val();
      this.colorHasChanged();
    }));

    $("body").on("input propertychange change", "." + this.shadeGapClass, debounce(400, () => {

      this.shadeGap = $(`.${this.shadeGapClass}`).val();
      this.colorHasChanged();
    }));



    $("body").on("mousedown", "." + this.advancedSettingsBtnClass, () => {

      return this.toggleAdvancedSettings();

    });

    // $("body").on("mousedown", "." + this.previewBtnClass, () => {

    //   return this.previewColorScheme();

    // });

    $("body").on("focus", "." + this.colorCodeInputClass, () => {

      return this.previewColorScheme();

    });

    // this.tintGapClass





  };

};
